<template>
    <div class="n2-center-container">
        <div id="n3-cancellation" class="n2-padding">
            <div>
                <app-content name="web.term.cancellation"></app-content>
            </div>
            <div class="n2-margin-top" style="position:relative; padding-bottom:20px; display:flex;">
                <div style="max-width:600px;">
                    <form-input type="text" v-model="model.booking_number"
                        v-bind:label="$t('pages.cancellation.booking_number')"
                        v-bind:errors="model_errors.booking_number"></form-input>
                    <form-input type="text" v-model="model.email" v-bind:label="$t('pages.cancellation.email')"
                        v-bind:errors="model_errors.email"></form-input>
                    <validation-summary v-bind:errors="model_errors"></validation-summary>
                    <div class="n2-margin-top">
                        <button class="n2-button-1" v-on:click="findBooking">{{ $t('pages.cancellation.find')
                            }}</button>
                    </div>
                    <div v-if="result_error" class="n2-margin-top">
                        <result-summary v-bind:error="result_error"></result-summary>
                    </div>
                </div>
            </div>


            <order-cancellation v-bind:order="order"></order-cancellation>


            <app-loader v-bind:active="loading"></app-loader>

        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { OrderService, CheckoutService, EmailService } from '../services'
import AppLoader from '../components/shared/loader.vue'
import FormInput from "../components/shared/form-input.vue"
import ValidationSummary from '../components/shared/validation-summary.vue';
import AppContent from '../components/shared/content.vue';
import OrderCancellation from '../components/app/order-cancellation.vue'
import ResultSummary from '../components/shared/result-summary.vue';

export default {
    components: {
        AppLoader, FormInput, ValidationSummary, AppContent, OrderCancellation, ResultSummary
    },

    data: function () {
        return {
            model: {},
            order: null,
            success: false,
            loading: false,
            result_error: '',
            model_errors: {}
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale',
        ]),
        ...mapGetters('identity', [
            'user'
        ]),
    },
    created: function () {
        this.orderService = new OrderService()
        this.checkoutService = new CheckoutService()
        this.emailService = new EmailService()
    },
    mounted: async function () {
    },
    methods: {
        validateForm: function () {
            this.model_errors = {}
            if (!this.model.booking_number) {
                this.model_errors['booking_number'] = [this.$t('pages.cancellation.error_booking_number')]
            }
            let patternEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!patternEmail.test(this.model.email)) {
                this.model_errors['email'] = [this.$t('pages.cancellation.error_email')]
            }

            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        findBooking: async function () {
            this.result_error = '';
            this.order = null;
            this.success = false;
            if (!this.validateForm()) {
                return
            }
            this.model.booking_number = this.model.booking_number.trim()
            this.model.email = this.model.email.trim()
            this.loading = true
            try {
                let o = await this.orderService.findAnonymous(this.model)
                this.order = o;
            }
            catch {
                this.result_error = this.$t('pages.cancellation.error_order_not_found')
            }
            finally {
                this.loading = false;
            }
        },



        getDateString: function (locale, source, format) { return new Date(source).toLocaleString(locale, { dateStyle: format }); },
        getLocalTimeString: function (locale, source) { return new Date(source.substr(0, 19) + 'Z').toLocaleString('no-NO', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Oslo' }); },
        getLocalDateString: function (locale, source, format) { return new Date(source.substr(0, 19) + 'Z').toLocaleString(locale, { dateStyle: format, timeZone: 'Europe/Oslo' }); },
        formatNumber: function (locale, source) { return Number(source).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
        getWeekday: function (locale, source) { return new Date(source).toLocaleString(locale, { weekday: 'long' }); },

    }
}
</script>
